import { Component, OnDestroy } from '@angular/core';
import { NavigationEnd, Router, Scroll } from '@angular/router';
import { AppConstants } from '@app/@core/entities/app-constants';
import { AuthService } from '@app/@core/services/auth.service';
import { HttpService } from '@app/@core/services/http.service';
import { SocketAdapterService } from '@app/@core/services/socket-adapter.server';
import { PermissionStore } from '@app/@core/store/permission.store';
import { environment } from '@env/environment';
import { BehaviorSubject, Subscription } from 'rxjs';
import { filter, map } from 'rxjs';
import { YouthPhotoService } from '../youth-photo/@core/youth-photo.service';
import { AssessmentConfig } from '@pics-core/page-builder'
import { LocalService } from '@core/services/local.service';
@Component({
  standalone: false,
  selector: 'app-page-designer',
  templateUrl: './page-designer.component.html',
  styleUrls: ['./page-designer.component.scss']
})
export class PageDesignerComponent implements OnDestroy {
  environment: any;
  permission: any;
  orgSubs: Subscription;
  commonService!: BehaviorSubject<any>;
  inputValidationMethod: any;
  message = '';
  subscription;

  constructor(
    private permissionStore: PermissionStore,
    private authService: AuthService,
    private httpService: HttpService,
    private youthPhotoService: YouthPhotoService,
    private socketAdapterService: SocketAdapterService,
    private router: Router,
    private sessionStorage: LocalService,
  ) {
    this.commonService = new BehaviorSubject<any>(null);
    this.orgSubs = this.authService.orgInfo.subscribe(org => {
      this.inputValidationMethod = AppConstants.onInput.bind(this);
      this.permission = this.permissionStore.state;
      const formioConfig: AssessmentConfig = {
        assessment: true,
        basic : false,
        premium : false,
        layout : false,
        advanced : false,
        data : false
      }
      this.environment = {
        tokenKey: 'jwt-token',
        apiHost: environment.apiHost,
        others: this.sessionStorage.asStorage(),
        orgID: org || this.sessionStorage.getItem('orgid'),
        formioConfig
      };
    });
    this.commonService.next({
      environment: this.environment,
      permission: this.permission,
      httpService: this.httpService,
      inputValidationMethod: this.inputValidationMethod,
      YOUTHPHOTOSERVICE: this.youthPhotoService,
      AUTHSERVICE: this.authService
    })
    this.router.events
    .pipe(
      filter((event) => event instanceof NavigationEnd || event instanceof Scroll)
    )
    .subscribe((event) => {
      const url = event instanceof NavigationEnd ? event.url : (event as Scroll).routerEvent.url;
      if (url.match(/\/page-design\/edit\/(\d+)\/([a-zA-Z-]+)$/)) {
        this.subscription = this.socketAdapterService.receivePageActiveUsers()
        .pipe(
          filter((users) => !!users?.length),
          map((users) => {
            if (/\/page-design\/edit\/(\d+)\/([a-zA-Z-]+)$/.exec(window.location.pathname)) {
              const [_, version, ...__] = window.location.pathname.match(/\/page-design\/edit\/(\d+)\/([a-zA-Z-]+)$/);
              return users.filter((u) => u.userid !== sessionStorage.getItem('id') && u.version === +version);
            } else {
              return [];
            }
          }),
        )
        .subscribe((users) => {
          if (users?.length) {
            this.message = `Another user ${users[0].username} is already editing this page.`;
          } else {
            this.message = '';
          }
        });
      } else {
        this.message = '';
        this.subscription?.unsubscribe();
      }
    });

  }

  ngOnDestroy(): void {
    this.orgSubs.unsubscribe();
  }

  onPageEnter($event) {
    this.socketAdapterService.emitUserEntered($event);
  }

  onPageLeave($event) {
    this.socketAdapterService.emitUserExit($event);
  }
}
